import React from "react";
import {
    Grid,
    FormControl,
    FormLabel,
    Select,
    Option,
    Box,
    Typography,
    Slider,
    Card,
    CardContent,
} from "@mui/joy";
import { Layers, Home, Percent } from "lucide-react";
import { SettingField, ESTIMATING_CONFIG } from "./EstimatingCommon";

interface SiteSetupProps {
    values: Record<string, any>;
    onChange: (key: string, value: any) => void;
}

export default function SiteSetup({ values, onChange }: SiteSetupProps) {
    return (
        <Card variant="soft" sx={{ border: "1px solid", borderColor: "divider" }}>
            <CardContent>
                <Typography level="title-sm" mb={2} startDecorator={<Home size={18} />}>
                    Site Setup & Structural Traits
                </Typography>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mb: 2.5 }}>
                    <SettingField label="Existing Layers">
                        <Select
                            size="sm"
                            value={values.EST_TEAR_OFF_LAYERS}
                            onChange={(_, val) => onChange("EST_TEAR_OFF_LAYERS", val)}
                            startDecorator={<Layers size={16} />}
                            sx={{ minWidth: 140 }}
                        >
                            {ESTIMATING_CONFIG.OPTIONS.LAYERS.map((opt) => (
                                <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                            ))}
                        </Select>
                    </SettingField>

                    <SettingField label="Story Height">
                        <Select
                            size="sm"
                            value={values.EST_STORIES}
                            onChange={(_, val) => onChange("EST_STORIES", val)}
                            sx={{ minWidth: 140 }}
                        >
                            {ESTIMATING_CONFIG.OPTIONS.STORIES.map((opt) => (
                                <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                            ))}
                        </Select>
                    </SettingField>
                </Box>

                <Box sx={{ px: 0.5 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                        <Typography level="title-sm" startDecorator={<Percent size={16} />}>
                            Waste Factor
                        </Typography>
                        <Typography level="title-sm" color="primary">
                            {values.EST_WASTE_FACTOR}%
                        </Typography>
                    </Box>
                    <Slider
                        value={values.EST_WASTE_FACTOR}
                        onChange={(_, val) => onChange("EST_WASTE_FACTOR", val)}
                        step={1}
                        min={5}
                        max={25}
                        marks={[
                            { value: 5, label: "5%" },
                            { value: 25, label: "25%" },
                        ]}
                    />
                </Box>
            </CardContent>
        </Card>
    );
}
